import routes from "@/routers/routes";
import PageHeader from "@/app/shared/page-header";
import { metaObject } from "@/config/site.config";
import ImportButton from "@/app/shared/import-button";
import CreateEditOrder from "@/app/shared/orders/create-edit";

export const metadata = {
    ...metaObject("Create Shipment"),
};

interface HeaderProps {
    isAgent: boolean;
}

export default function CreateOrderPage({ isAgent }: HeaderProps) {
    const pageHeader = {
        title: isAgent == false ? "Request Order" : "Request Shipment",
        breadcrumb: [
            {
                href: routes.eCommerce.dashboard,
                name: "Dashboard",
            },
            {
                name: isAgent == false ? "Request Order" : "Request Shipment",
            },
        ],
    };

    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            ></PageHeader>

            <CreateEditOrder isEdit={false} isAgent={isAgent} />
        </>
    );
}
